import 'css-chunk:src/app/containers/MemberDetail/components/MemberDetails/MemberDetails.scss';export default {
  "Collapse": "_Collapse_yfxhj_1",
  "memberDetailsCard": "_memberDetailsCard_yfxhj_23",
  "header": "_header_yfxhj_32",
  "headerUserInfo": "_headerUserInfo_yfxhj_38",
  "headerUserName": "_headerUserName_yfxhj_44",
  "agentInfoIcon": "_agentInfoIcon_yfxhj_54",
  "agentHeader": "_agentHeader_yfxhj_60"
};